// extracted by mini-css-extract-plugin
export default {"base":"EditUploadMod_base__N5Gbz","label":"EditUploadMod_label__SWurO","field":"EditUploadMod_field__HDZgJ","fileUploadSummary":"EditUploadMod_fileUploadSummary__DDlRu"};